import { inputBaseClasses, styled } from '@mui/material';
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers';

export const TimePicker = styled(MuiTimePicker)(({ theme }) => ({
  [`.${inputBaseClasses.root}`]: {
    height: '3rem',
  },
  [`.${inputBaseClasses.input}`]: {
    fontSize: theme.typography.fontSize,
  },
}));
